import React, {Component} from "react";
import {connect} from "react-redux";
import MKLogo from "./svg/MKLogo";

import "./Loading.css";

const ReactProgressCircle = ({percentage, size}) => {
  let appliedRadius;
  let appliedStroke;
  switch (size) {
    case 'xs':
      appliedRadius = 10;
      appliedStroke = 1;
      break;
    case 'sm':
      appliedRadius = 25;
      appliedStroke = 1;
      break;
    case 'md':
      appliedRadius = 50;
      appliedStroke = 5;
      break;
    case 'lg':
      appliedRadius = 75;
      appliedStroke = 7.5;
      break;
    case 'xl':
      appliedRadius = 100;
      appliedStroke = 10;
      break;
    default:
      appliedRadius = 50;
      appliedStroke = 5;
  }
  const normalizedRadius = appliedRadius - appliedStroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset =
    circumference - (percentage / 100) * circumference;
  return (
    <div id="fow-loading-circle">
      <svg height={appliedRadius * 2} width={appliedRadius * 2}>
        <circle
          className='fow-loading-circle-back'
          strokeWidth={appliedStroke}
          style={{strokeDashoffset}}
          r={normalizedRadius}
          cx={appliedRadius}
          cy={appliedRadius}
        />
        <circle
          className='fow-loading-circle-circle'
          strokeWidth={appliedStroke}
          strokeDasharray={circumference + ' ' + circumference}
          style={{strokeDashoffset}}
          r={normalizedRadius}
          cx={appliedRadius}
          cy={appliedRadius}
        />
      </svg>
    </div>
  );
};

class Loading extends Component {

  render() {
    const {loading, list, max} = this.props;

    const progress = 100 - (list.length * 100) / max;

    return (
      <div id="fow-loading"
        className={loading ? "show" : "hide"}
      >
        {loading &&
          <div id="fow-loading-inner">
            <ReactProgressCircle size="sm" percentage={progress===0?15:progress} />
            <MKLogo width="100" />
            <span className="fow-font-text fow-font-size-sm">Loading...</span>
            <span className="fow-font-text fow-font-size-xs">{list[0]?list[0].name:'test'}</span>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.db.loading,
    list: state.db.loadingList,
    max: state.db.loadingMax
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Loading);
